import { useState } from 'react';
import { ChevronDown, Coins, HandHeart } from 'lucide-react';
import { useHelpCenter } from '@/lib/helpCenter';

/** Shown the moment a student picks a board we haven't built yet, and again in
 *  the upload dialog. The ask is honest: help us, and we pay you in coins. */
export function ContributionNotice({ board = '', compact = false }) {
  const help = useHelpCenter();
  const [open, setOpen] = useState(false);
  const intro = help.scan_intro || '';
  const guidelines = help.scan_guidelines || '';
  if (!intro && !guidelines) return null;
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/70 p-3" data-testid="contribution-notice">
      <p className="text-[12px] font-heading text-amber-900 flex items-start gap-1.5">
        <HandHeart className="w-3.5 h-3.5 mt-[2px] flex-shrink-0" />
        {board ? `${board} isn’t in our library yet — you can change that.` : 'Help us build your board'}
      </p>
      {!compact && <p className="text-[12px] font-body text-amber-900/90 mt-1 whitespace-pre-line">{intro}</p>}
      <p className="text-[11px] font-heading text-amber-800 mt-1.5 inline-flex items-center gap-1">
        <Coins className="w-3 h-3" /> 100 Veda Coins for every chapter we approve
      </p>
      {guidelines && (
        <>
          <button type="button" data-testid="scan-guidelines-toggle"
            onClick={() => setOpen(o => !o)}
            className="mt-2 flex items-center gap-1 text-[11px] font-heading text-amber-800 hover:underline">
            How to scan properly
            <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
          </button>
          {open && (
            <p data-testid="scan-guidelines-body"
              className="mt-1.5 text-[11px] font-body text-amber-900/90 whitespace-pre-line leading-relaxed">
              {guidelines}
            </p>
          )}
        </>
      )}
    </div>
  );
}

export default ContributionNotice;
